import { LocationType } from '../types/site';
import { NewSite } from '../types/sites';

export const getAddressString = (row: NewSite | undefined) => {
  if (!row) return '';
  const street = row && row.location && row.location.street;
  const city = row && row.location && row.location.city;
  const state = row && row.location && row.location.state;
  const zip = row && row.location && row.location.zip;
  const country = row && row.location && row.location.country;
  const addressComponents = [street, city, state, zip, country].filter(Boolean);
  const address = addressComponents.join(', ');

  return address;
};

export const getAddressStringFromLocation = (location: LocationType) =>
  [location.street, location.city, location.state, location.zip, location.country]
    .filter(Boolean)
    .join(', ');

export const getCoordinatesString = (row: NewSite | undefined) => {
  const latitude = row?.location?.latitude;
  const longitude = row?.location?.longitude;
  if (latitude && longitude) return `${latitude},${longitude}`;
  return getAddressString(row);
};

export const getCoordinatesStringFromLocation = (location: LocationType) => {
  if (location?.latitude && location?.longitude) {
    return `${location.latitude},${location.longitude}`;
  }
  return getAddressStringFromLocation(location);
};
